import { ReactLenis } from "lenis/react";
import { LanguageProvider } from "@/i18n/LanguageContext";
import { Header } from "@/components/osrelis/Header";
import { Hero } from "@/components/osrelis/Hero";
import { About } from "@/components/osrelis/About";
import { Approach } from "@/components/osrelis/Approach";
import { Marquee } from "@/components/osrelis/Marquee";
import { Capabilities } from "@/components/osrelis/Capabilities";
import { DevelopmentModel } from "@/components/osrelis/DevelopmentModel";
import { Opportunities } from "@/components/osrelis/Opportunities";
import { Partnership } from "@/components/osrelis/Partnership";
import { VisualBand } from "@/components/osrelis/VisualBand";
import { Faq } from "@/components/osrelis/Faq";
import { Gallery } from "@/components/osrelis/Gallery";
import { Contact } from "@/components/osrelis/Contact";
import { Footer } from "@/components/osrelis/Footer";
import { CustomCursor, ScrollProgress } from "@/components/osrelis/enhancements";

export default function Home() {
  return (
    <LanguageProvider>
      <ReactLenis root options={{ lerp: 0.09, smoothWheel: true }}>
        <div className="grain-overlay" aria-hidden="true" />
        <ScrollProgress />
        <CustomCursor />
        <Header />
        <main>
          <Hero />
          <About />
          <Approach />
          <Marquee />
          <Capabilities />
          <DevelopmentModel />
          <Opportunities />
          <Partnership />
          <VisualBand />
          <Faq />
          <Gallery />
          <Contact />
        </main>
        <Footer />
      </ReactLenis>
    </LanguageProvider>
  );
}
